import { siteNameGenerator } from 'helpers/site-name-generator';
import { get } from 'lodash';
import moment from 'moment';
import * as Yup from 'yup';
import StatusCell from './StatusCell';

const today = new Date();
today.setHours(0, 0, 0, 0);

export const columns = [
  { field: 'id', headerName: 'ID', width: 90 },
  {
    field: 'organization_name',
    headerName: 'Organization',
    width: 200,
  },
  {
    field: 'status',
    headerName: 'Status',
    width: 160,
    renderCell: StatusCell,
  },
  {
    field: 'service_name',
    headerName: 'Service Name',
    width: 180,
  },
  {
    field: 'site_name',
    headerName: 'Site Name',
    width: 240,
  },
  {
    field: 'address',
    headerName: 'Address',
    width: 200,
  },
  {
    field: 'city',
    headerName: 'City',
    width: 130,
  },
  {
    field: 'state',
    headerName: 'Province/State',
    width: 180,
  },
  {
    field: 'state',
    headerName: 'Country',
    width: 180,
  },
  {
    field: 'start_date',
    headerName: 'Start Date',
    type: 'date',
    width: 150,
  },
  {
    field: 'end_date',
    headerName: 'End Date',
    type: 'date',
    width: 150,
  },
  {
    field: 'start_time',
    headerName: 'Start Time',
    width: 150,
  },
  {
    field: 'end_time',
    headerName: 'End Time',
    width: 150,
  },
  {
    field: 'booking_cutoff_days_num',
    headerName: 'Cut Off',
    type: 'date',
    width: 180,
  },
];

export const suggestionPrimaryKey = 'organization_name';
export const suggestionSecondaryKeys = [
  'site_name',
  'address',
  'city',
  'state',
];

export const initialValues = (clinic) => ({
  organizationId: get(clinic, 'organization_id', ''),
  subLocationId: get(clinic, 'sublocation_id', ''),
  startDate: clinic
    ? moment(clinic.start_date).format('YYYY/MM/DD')
    : new Date(),
  startTime: get(clinic, 'start_time', new Date()),
  endTime: get(clinic, 'end_time', new Date()),
  endDate: clinic ? moment(clinic.end_date).format('YYYY/MM/DD') : new Date(),
  bookingCutOffDaysNum: get(clinic, 'booking_cutoff_days_num', 0),
  serviceId: get(clinic, 'service_id', ''),
  serviceDuration: get(clinic, 'service_duration', ''),
  estimatedParticipants: get(clinic, 'estimated_participants', ''),
  actualParticipants: get(clinic, 'actual_participants', ''),
  schedulerId: get(clinic, 'schedule_id', ''),
  multiDays: get(clinic, 'multi_days', 0),
  concurrentSlots: get(clinic, 'concurrent_slots', 1),
});

export const validationSchema = (allowBeforeToday) =>
  Yup.object().shape({
    organizationId: Yup.string().required('field is required'),
    subLocationId: Yup.string().required('field is required'),
    serviceId: Yup.string().required('field is required'),
    startDate: Yup.date('invalid date')
      .when(() => {
        if (!allowBeforeToday) {
          return Yup.date().min(
            moment().startOf('day'),
            "start date can't be before today's date",
          );
        }
      })
      .required('field is required'),
    startTime: Yup.string().required('field is required'),
    endDate: Yup.date('invalid date')
      .when(() => {
        if (!allowBeforeToday) {
          return Yup.date().min(
            moment().startOf('day'),
            "end date can't be before today's date",
          );
        }
      })
      .required('field is required'),
    endTime: Yup.string(),
    bookingCutOffDaysNum: Yup.number().required('field is required'),
    serviceDuration: Yup.string(),
    estimatedParticipants: Yup.string().required('field is required'),
    actualParticipants: Yup.string(),
    schedulerId: Yup.string(),
    multiDays: Yup.number(),
    concurrentSlots: Yup.number().required('field is required'),
  });
